// extracted by mini-css-extract-plugin
module.exports = {"error":"e404_error__2kvcf","text1":"e404_text1__iYTIM"};